module.exports = __webpack_public_path__ + "static/img/PR.4373bf6a.svg";